export enum ClientTypeEnum {
  LEGAL_ENTITY = '1', // Юридическое лицо
  INDIVIDUAL_PERSON = '2', // Физическое лицо
  INDIVIDUAL_ENTREPRENEUR = '3', // Индивидуальный предприниматель
  PRIVATE_PRACTITIONER = '4', // Физическое лицо, занимающееся частной практикой
  FOREIGN_STRUCTURE = '5', // Иностранная структура без образования юридического лица
}
